import React, {
  useState,
} from 'react';
import clsx from 'clsx';
import Button from 'pages/Dashboard/components/Button';
import Popover from 'core/components/Popover';
import isNil from 'lodash/isNil';
import InsuranceEligibilityList, {
  ListProps,
} from 'pages/Dashboard/pages/Appointments/pages/List/components/Details/PatientInsuranceList/List';
import ToolTip from 'core/components/Tooltip';

type Props = ListProps & {
  disabled?: boolean;
  isLoading?: boolean;
};

export default function PatientInsuranceEligibility({
  disabled: _disabled,
  isLoading,
  patient,
  ...props
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const hasNoInsurance = (patient?.insurances ?? []).length === 0;
  const disabled = isLoading || _disabled || hasNoInsurance;

  return (
    <>
      <ToolTip
        title={hasNoInsurance && (
        <>
          Patient has no insurance.
          <br />
          Please add insurance first.
        </>
        )}
        hide={!hasNoInsurance}
      >
        <span>
          <Button
            className={clsx('!border-secondary !px-2.5 !py-0.5 order-2 disabled:!border-gray-300', {
              '!cursor-not-allowed !pointer-events-auto': disabled,
            })}
            variant="outlined"
            color="primary"
            onClick={(e) => { setAnchorEl(e.currentTarget.closest('.populate-information-row') as HTMLElement); }}
            disabled={disabled}
          >
            Check Eligibility
          </Button>
        </span>
      </ToolTip>
      {!isNil(anchorEl) && (
        <Popover
          anchorEl={anchorEl}
          disableEscapeKeyDown={false}
          disableScrollLock={false}
          onClose={() => { setAnchorEl(null); }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          classes={{
            paper: '!w-[608px] !overflow-y-visible !overflow-x-visible populate-form',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <InsuranceEligibilityList
            {...props}
            patient={patient}
            onClose={() => { setAnchorEl(null); }}
          />
        </Popover>
      )}
    </>
  );
}
